import { useEffect, useState, useContext, useRef } from "react"; 
import { ChatContext } from "../context/ChatContext";  
// import DataTable from 'react-data-table-component'; // Replaced with regular table
import { XCircleIcon, CheckCircleIcon } from "@heroicons/react/24/outline"; 
import edamsApi from "../../../../models/edamsModel";  

const SideChatAccount = () => {
const { data, dispatch } = useContext(ChatContext); 
// const [isCustomer, setIsCustomer] = useState(false); // Removed, will derive from context directly
const [newCommentText, setNewCommentText] = useState(""); 
const [commentStatus, setCommentStatus] = useState({ message: "", type: "" });  

useEffect(() => {
    // Concise log for SideChatAccount's perspective on data
    console.log(
        `SideChatAccount Effect: accountNo=${data.accountNo}, isAccountDataLoading=${data.isAccountDataLoading}, accountDataExists=${!!(data.accountData && data.accountData.account && Object.keys(data.accountData.account).length > 0)}`
    );
    // No cleanup function needed for this simplified logging effect.
    // If you were managing subscriptions or timers, a cleanup would be essential.
  }, [data.accountData, data.accountNo, data.isAccountDataLoading, data._accountDataVersion ]); // Simplified dependencies
 
  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    if (!newCommentText.trim()) {
      setCommentStatus({ message: "Comment cannot be empty.", type: "error" });
      return;
    }
 
    // Guard against null data.accountData before accessing its properties
    if (!data.accountNo || !data.accountData || !data.accountData.edams_user) {
      setCommentStatus({ message: "Missing account number or EDAMS user. Cannot submit comment.", type: "error" });
      console.error("Missing account number or EDAMS user for comment submission:", { accountNo: data.accountNo, edams_user: data.accountData?.edams_user });
      return;
    }

    setCommentStatus({ message: "Submitting...", type: "loading" });

    try {
      const response = await edamsApi.addAccountComment(
        data.accountNo,
        newCommentText,
        data.accountData.edams_user,
        new Date().toISOString()
      ); 
      if (response && response.status == 1) {         
        setCommentStatus({ message: response.message || "Comment submitted successfully!", type: "success" });
        setNewCommentText("");
      } else {
        setCommentStatus({ message: response.message || "Failed to submit comment. Please try again.", type: "error" });
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
      setCommentStatus({ message: "An error occurred while submitting the comment.", type: "error" });
    }
  };

  switch(data.tab){
    case "Home": {
      // Derive whether to show customer data directly from context for the current render
      const showCustomerData = !data.isAccountDataLoading && data.accountData && data.accountData.account && Object.keys(data.accountData.account).length > 0;
       return (
        <div className="bg-white shadow-xl rounded-2xl m-6 border border-gray-200">
          <div className="p-6 min-h-[12rem] flex flex-col"> {/* Added min-height and flex */}
            {showCustomerData ? (<>
            {/* Standardized title styling */}
            <h3 className="text-xl font-semibold text-gray-800 mb-4"> {/* Keeping customer name distinct */}
              {(data.accountData.account?.TITLE ?? "") + " " +
                (data.accountData.account?.INITIAL ?? "") + " " +
                (data.accountData.account?.SURNAME ?? "")}
            </h3>
            <div className="text-gray-500 mb-4">
              <div className="flex flex-col">
                <div className="w-full leading-relaxed">
                  {data.accountData.account?.UA_ADRESS1 ?? ""}<br/>
                  {data.accountData.account?.UA_ADRESS2 ?? ""}<br/>
                  {data.accountData.account?.UA_ADRESS3 ?? ""}<br/>
                  {data.accountData.account?.UA_ADRESS4 ?? ""}<br/>
                  {data.accountData.account?.UA_ADRESS5 ?? ""}
                </div>
              </div>
            </div>
            
              <div className="flex flex-col">
                <div className="overflow-x-auto border-t border-gray-200 pt-4">
                  <table className="min-w-full">
                    <tbody>
                      <tr>
                        <td className="py-2 whitespace-nowrap text-sm font-semibold text-gray-700">Balance</td>
                        <td className="py-2 whitespace-nowrap text-sm text-gray-900 text-right">R{data.accountData.balance}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> 

              {Array.isArray(data.accountData.comments) && data.accountData.comments.length > 0 && (
              <div className="mt-6 border-t border-gray-200 pt-6"> 
                <div className="bg-gray-50 p-3 rounded-lg shadow-sm border border-gray-100">
                  <div className="flex flex-wrap items-center justify-between mb-2">
                    <div className="flex items-center mr-3 mb-1 sm:mb-0"> {/* Comment author avatar */}
                      <div className="flex-shrink-0 w-7 h-7 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center font-semibold text-xs mr-2">
                        {data.accountData.comments[0]["Created By"] ? data.accountData.comments[0]["Created By"].charAt(0).toUpperCase() : <span>💬</span>}
                      </div>
                      <span className="text-xs font-semibold text-gray-700">
                        {data.accountData.comments[0]["Created By"] || "Unknown User"}
                      </span>
                    </div>
                    <span className="text-xs text-gray-500 whitespace-nowrap">
                      {data.accountData.comments[0]["Created on"]}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-wrap">
                    {data.accountData.comments[0]["Comment"]}
                  </p>
                </div>
              </div>
              )} 
          
              <div className="mt-6 border-t border-gray-200 pt-6">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Add New Comment</h4>
                <form onSubmit={handleCommentSubmit} className="space-y-4">
                  <div>
                    <label htmlFor="newComment" className="sr-only">Comment</label>
                    <textarea
                      id="newComment"
                      name="newComment"
                      rows={3}
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-sky-500 focus:ring-sky-500 sm:text-sm p-2"
                      placeholder="Type your comment here..."
                      value={newCommentText}
                      onChange={(e) => setNewCommentText(e.target.value)}
                    />
                  </div>
                  {commentStatus.message && (
                    <p className={`text-sm ${commentStatus.type === 'error' ? 'text-red-600' : commentStatus.type === 'success' ? 'text-green-600' : 'text-gray-600'}`}>
                      {commentStatus.message}
                    </p>
                  )}
                  <button
                    type="submit"
                    disabled={commentStatus.type === 'loading'}
                    className="inline-flex justify-center rounded-md border border-transparent bg-emerald-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 disabled:opacity-50"
                  >
                    {commentStatus.type === 'loading' ? 'Submitting...' : 'Submit Comment'}
                  </button>
                </form>
              </div>
           </>) : (
            <div className="flex-grow flex flex-col items-center justify-center"> {/* Centering container for loading/empty state */}
              {data.isAccountDataLoading ? (
                <div className="flex flex-col items-center gap-3">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sky-600"></div>
                  <div className="text-gray-600">Loading account details...</div>
                </div>
              ) : data.accountNo ? (
                <div className="text-center text-gray-500">
                  <p className="font-medium text-gray-700">Account: {data.accountNo}</p>
                  <p className="text-sm mt-2">Unable to load customer data</p>
                  <p className="text-xs mt-1 text-gray-400">Check console for errors</p>
                </div>
              ) : (
                <div className="text-gray-500">No Account Data</div>
              )}
            </div>
           ) }
          </div>
        </div>
      );
    }
    // Ensure other cases also safely access data.accountData
    case "Transactions":
      return (
        <div className="bg-white shadow-xl rounded-2xl m-6 border border-gray-200">
          <div className="p-6 min-h-[12rem] flex flex-col"> {/* Added min-height and flex */}
            <h2 className="text-xl font-semibold text-sky-700 mb-4">Transactions</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border-collapse">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">#</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">Date</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">Type</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">Description</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">Amount</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">Vat</th>
                    <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b">Balance</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {(data.accountData?.transactions || []).map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{row.No}</td>
                      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{row.Date}</td>
                      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{row.Type}</td>
                      <td className="px-3 py-2 text-sm text-gray-900">{row.Description}</td>
                      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{row.Amount}</td>
                      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{row.Vat}</td>
                      <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900">{row.Balance}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {(!data.accountData?.transactions || data.accountData.transactions.length === 0) && (
                <div className="text-center py-4 text-gray-500">No transactions found</div>
              )}
            </div>
          </div>
        </div>
      );

    case "Comments":
      return (
        <div className="bg-white shadow-xl rounded-2xl m-6 border border-gray-200">
          <div className="p-6 space-y-6 min-h-[12rem] flex flex-col"> {/* Added min-height and flex */}
            <h2 className="text-xl font-semibold text-sky-700 mb-4">Comments</h2>
            {data.accountData && Array.isArray(data.accountData.comments) && data.accountData.comments.length > 0 ? (
              data.accountData.comments.map((comment, i) => (
                <div
                  key={comment.EVENT_ID || i}
                  // Styling for individual comment items can remain, this is about the tab's container
                  className="relative flex bg-white w-full shadow-lg my-3 rounded-xl border border-gray-200 hover:shadow-xl transition-shadow"
                >
                  <div className="w-2 h-full bg-sky-500 rounded-l-xl" /> 
                  <div className="flex-1 p-4">
                    <div className="flex flex-wrap items-center justify-between mb-2"> 
                      <div className="flex items-center mr-3 mb-1 sm:mb-0">
                        <div className="flex-shrink-0 w-8 h-8 bg-sky-100 text-sky-600 rounded-full flex items-center justify-center font-semibold text-sm">
                          {comment["Created By"] ? comment["Created By"].charAt(0).toUpperCase() : <span>💬</span>}
                        </div>
                        <span className="ml-2 text-sm font-semibold text-gray-700">
                          {comment["Created By"] || "Unknown User"}
                        </span>
                      </div>
                      <span className="text-xs text-gray-500 whitespace-nowrap">
                        {comment["Created on"]}
                      </span>
                    </div>
                    <div className="text-gray-700 text-sm leading-relaxed whitespace-pre-wrap">
                      {comment["Comment"]}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex-grow flex flex-col items-center justify-center text-gray-400"> {/* Centering container for empty state */}
                No comments available.
              </div>
            )}
          </div>
        </div>
      );

    case "Connection":
      return (
        <div className="bg-white shadow-xl rounded-2xl m-6 border border-gray-200">
          <div className="p-6 min-h-[12rem] flex flex-col"> {/* Standardized min-height and flex */}
            <div className="flex-grow flex flex-col items-center justify-center"> {/* Use flex-grow for centering content */}
              <h2 className="text-xl font-semibold text-sky-700 mb-4">Connection Status</h2>
          {data.accountData?.connection_status == 2 ? ( // Safe access
            <div className="text-center p-10">
              <XCircleIcon className="h-20 w-20 text-red-400 mx-auto" aria-hidden="true" />
              <p className="mt-4 text-lg text-red-500 font-semibold">Disconnected</p>
            </div>
          ) : (
            <div className="text-center p-10">
              <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" aria-hidden="true" />
              <p className="mt-4 text-lg text-green-600 font-semibold">Connected</p>
            </div>
          )}
            </div>
          </div>
        </div>
      );

    default:
      return null;
  }
};

export default SideChatAccount;
